var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isShow)?_c('LvText',{staticClass:"lv-snack-bar",attrs:{"h5":"","white":""}},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }